<template>
  <div class="row mb-1" v-if="!isLoading">  
    <div class="col-md-4 mb-1 pr-1 text-right col-xs-12">
      <div class="w-25 float-left text-right mt-1">
        <small>
        +{{ paisCodTel(miPhone.country_id) }}&nbsp;
        </small>
      </div>
      <input
        type="text"
        class="form-control w-75 text-center"
        v-model="miPhone.phone"
        disabled
      />
    </div>
    <div class="col-1 pr-0 m-0 float-right d-xs-none">
      <country-flag
        class="float-right pr-0"
        :country="paisCode(miPhone.country_id)"
        size="normal"
      ></country-flag>
    </div>

    <div class="col-md-4 pl-1">
      <select
        class="form-control w-100 float-left"
        disabled
        v-model="miPhone.country_id"
      >
        <option
          v-for="pais in countries"
          v-bind:key="pais.id"
          v-bind:value="pais.id"
          >{{
            pais.name
              | filterTranslateCountry(pais.id, pais.translations, $i18n.locale)
          }}</option
        >
      </select>
    </div>
    <!-- <div class="col-md-1">
      <i class="fa fa-2x fa-times-circle text-warning ml-0 hover"></i>
    </div>-->
    <div class="col-md-3">
      <button
        type="button"
        class="btn btn-sm btn-outline-danger btn-gr float-right"
        @click="eliminarTelefono"

      >
        <i aria-hidden="true" class="fa fa-trash-o"></i>
      </button>

      <button
        type="button"
        class="btn btn-sm btn-outline-primary btn-gr float-right mr-1"
        @click="$emit('emitEditarTel')"
      >
        <i aria-hidden="true" class="fa fa-edit"></i>
      </button>
      <!--  <button
        class="btn btn-sm btn-outline-danger ml-1  float-right pt-2 pb-2 btn-w"
        role="button"
      >
        {{ $t("eliminar") }}
        <i class="fa fa-times-circle"></i>
      </button> -->
    </div>
  </div>
</template>
<script>
import CountryFlag from "vue-country-flag";
import _ from "lodash";
export default {
  props: ["phone", "countries", "locale"],
  data:() => ({
     isLoading: true,
      principal: false,
      miPhone: {}
  }) ,
  components: { CountryFlag },
  computed: {},
  methods: {
    /* funcion para eliminar un telefono */
    eliminarTelefono() {
      console.log(this.miPhone.id)
      this.$emit('emitEliminarTel', this.miPhone.id)
    },
    paisCode(id) {
      const country = this.countries.find(c => c.id === id);     
      if (!!country.iso) {
        return country.iso.toLowerCase();
      } else {
        return "";
      }
    },
    paisCodTel(id) {
      const country = this.countries.find(c => c.id === id);
      //console.log(country, !country.iso);
      if (!!country.phonecode) {
        return country.phonecode;
      } else {
        return "";
      }
    }
  },
  destroyed() {
console.log("destruido la lista")
  },
  mounted() {
     console.log("montada la lista");
    this.miPhone = this.phone;
    this.isLoading = false;
  }
};
</script>

<style scoped>
.hover:hover {
  color: red !important;
  cursor: pointer;
}

input,
select {
  max-height: 35px;
  margin-left: 0px;
  background-color: #fff;
  border: 1px solid #ccc;
}

select {
  padding: 1px;
}
</style>
